<!-- Outer wrapper: applies React's dialog content styling -->
<div class="form-offline-wrapper px-7 pt-14 pb-6 md:px-10 md:pt-18" style="background-color: oklch(0.985 0.008 150)">
  <!-- Header -->
  <div class="form-offline-header">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h3 *ngIf="!edit" class="header-title">Cotización offline</h3>
        <h3 *ngIf="edit && !reopen" class="header-title">Solicitud offline</h3>
        <h3 *ngIf="edit && reopen" class="header-title">Reabrir solicitud</h3>
        <p
          *ngIf="!edit"
          class="d-flex align-items-center mt-2"
          style="
            gap: 0.75rem;
            font-family: &quot;Inter&quot;, sans-serif;
            font-size: 16px;
            line-height: 1.15;
            color: #404040;
            margin-bottom: 0;
          "
        >
          <span
            class="d-inline-flex align-items-center justify-content-center"
            style="
              height: 36px;
              width: 36px;
              flex-shrink: 0;
              border: 1px solid #bfe6cd;
              background-color: #e4f5ea;
              border-radius: 10px;
              color: #171717;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <line x1="10" y1="9" x2="8" y2="9" />
            </svg>
          </span>
          Solicitá cotizaciones personalizadas. Si encontraste un precio más bajo, compartilo y lo revisamos.
        </p>
      </div>
      <button type="button" class="btn-close-modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <!-- Tabs: React TabButton style -->
  <div *ngIf="!edit" class="tabs-container">
    <button class="btn-tab" [class.active]="tab === 'hotel'" (click)="tabActive('hotel')">HOTEL</button>
    <button class="btn-tab" [class.active]="tab === 'transfer'" (click)="tabActive('transfer')">TRASLADO</button>
    <button class="btn-tab" [class.active]="tab === 'experience'" (click)="tabActive('experience')">EXPERIENCIA</button>
    <button class="btn-tab" [class.active]="tab === 'ticket'" (click)="tabActive('ticket')">TICKET</button>
  </div>

  <!-- Edit mode header -->
  <div *ngIf="edit" class="d-flex flex-column my-3 px-5 edit-header">
    <h3 class="mb-0" *ngIf="editData.category === 'hotels'">Hotel</h3>
    <h3 class="mb-0" *ngIf="editData.category === 'transfers'">Traslado</h3>
    <h3 class="mb-0" *ngIf="editData.category === 'rentacar'">Rent a car</h3>
    <p class="mb-0" *ngIf="editData.category === 'transfers'">
      <span>Traslado:</span>
      <span class="transfer-direction">
        {{ editData.oneWay ? " Solo ida" : " Ida y vuelta" }}
      </span>
    </p>
  </div>

  <div [ngClass]="{ 'd-block': tab === 'hotel', 'd-none': tab != 'hotel' }">
    <form *ngIf="tab === 'hotel' && formHotel" [formGroup]="formHotel" class="d-flex flex-column">
      <!-- Single card wrapper for the hotel form -->
      <div class="hotel-form-card" data-form-invalid="hotel">
        <usb-request-header
          [formGroup]="formHotel"
          [selectedFile]="selectedFile"
          [selectedClient]="selectedClient"
          [availablePax]="availablePax"
          [loadingFiles]="loadingFiles"
          [loadingPax]="loadingPax"
          [showNewFileNameInput]="showNewFileNameInput"
          [showNewClientInput]="showNewClientInput"
          [existingFiles]="existingFiles"
          [countriesData]="countriesData"
          [loadingCountries]="loadingCountries"
          [newFilePassenger]="newFilePassenger"
          [newFilePassengerError]="newFilePassengerError"
          [newFilePhoneCode]="newFilePhoneCodeModel"
          [newFilePhoneCodeError]="newFilePhoneCodeError"
          [newFilePhone]="newFilePhone"
          [newFilePhoneError]="newFilePhoneError"
          [newFileEmail]="newFileEmail"
          [newFileEmailError]="newFileEmailError"
          [phoneCodeSelected]="phoneCodeSelected"
          [selectedFileId]="selectedFileId"
          [selectedClientId]="selectedClientId"
          [phoneCodeError]="formHotel.get('client.phone_code')?.hasError('required') && formHotel.get('client.phone_code')?.touched"
          [firstNameError]="formHotel.get('client.first_name')?.hasError('required') && formHotel.get('client.first_name')?.touched"
          [lastNameError]="false"
          [emailError]="formHotel.get('client.email')?.invalid && formHotel.get('client.email')?.touched"
          [requiredFieldMessage]="requiredFieldMessage"
          [getFileLabel]="getFileLabel"
          [getClientLabel]="getClientLabel"
          [getClientsForSelectedFile]="getClientsForSelectedFile"
          [isNuevoFileValid]="isNuevoFileValid"
          [blockInvalidKeys]="blockInvalidKeys"
          [displayCountryFn]="displayCountryFn"
          (fileChange)="onFileChange($event)"
          (fileSearchInput)="onFileSearchInput($event)"
          (clearSelectedFile)="clearSelectedFile()"
          (clientChange)="onClientChange($event)"
          (passengerIdChange)="onPassengerIdChange($event)"
          (newFileToggle)="openNewFileNameInput()"
          (newClientToggle)="cancelNewClient()"
          (newFileSubmit)="onCreateNewFile()"
          (newClientSubmit)="onCreateNewClient($event)"
          (newFilePassengerInput)="onNewFilePassengerInput($event)"
          (newFilePhoneCodeInput)="onNewFilePhoneCodeInput($event)"
          (newFileCountrySelected)="onNewFileCountrySelected($event)"
          (newFilePhoneInput)="onNewFilePhoneInput($event)"
          (newFileEmailInput)="onNewFileEmailInput($event)"
          (countrySelected)="onCountrySelected($event)"
          (phoneCodeInput)="onPhoneCodeInput($event)"
        ></usb-request-header>

        <hr class="mt-4 mb-5 p-0" style="border-color: oklch(70.8% 0 0)" />

        <!-- ============================================= -->
        <!-- BLOCK 2: Destino y fechas -->
        <!-- ============================================= -->
        <section class="border-t border-neutral-400 pt-8 mb-5">
          <div class="block-header">
            <div class="block-number">2</div>
            <div class="block-header-text">
              <p class="block-title">Destino y fechas</p>
              <p class="block-caption">Completá la información del hotel que estás cotizando.</p>
            </div>
          </div>
          <div class="block-body">
            <!-- Row A: Destino (col-6) + Check-in (col-3) + Check-out (col-3) -->
            <div class="row" style="align-items: flex-start">
              <div class="col-6 d-flex flex-column" style="position: relative">
                <label class="field-label" for="destination">Destino <span class="required-marker">*</span></label>
                <div class="position-relative w-100">
                  <span
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="left: 12px; top: 50%; transform: translateY(-50%); color: #171717; pointer-events: none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    id="destination"
                    name="destination"
                    class="form-control"
                    style="padding-left: 40px"
                    placeholder="Ciudad, país o región"
                    [maxLength]="80"
                    [minLength]="3"
                    formControlName="destination"
                    [matAutocomplete]="autoDestination"
                    autocomplete="off"
                  />
                </div>
                <mat-autocomplete
                  #autoDestination="matAutocomplete"
                  [displayWith]="displayDestinationFn"
                  (optionSelected)="onDestinationSelected($event.option.value)"
                >
                  <ng-container *ngFor="let item of destinationOptions">
                    <ng-container *ngIf="item.type === 'city' && item.cities && item.cities.length > 0">
                      <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center" style="gap: 0.25em">
                            <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                            <span
                              class="mt-1"
                              style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                              >Ubicación</span
                            >
                          </div>
                          <div>
                            <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                              {{ item.cities.length }} resultados
                            </span>
                          </div>
                        </div>
                      </mat-option>
                      <mat-option *ngFor="let city of item.cities" [value]="city">
                        <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                          <img src="{{ city?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                          <p
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                          >
                            {{ capitalize(city.city_name) }},
                            <span
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot;;
                                font-size: 12px !important;
                                line-height: 1;
                                font-weight: 400 !important;
                              "
                            >
                              {{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                              {{ capitalize(city.country_name) }}
                            </span>
                          </p>
                        </div>
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </mat-autocomplete>
                <span
                  *ngIf="formHotel.get('destination')?.hasError('required') && formHotel.get('destination')?.touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px"
                >
                  {{ requiredFieldMessage('hotel', 'destination') }}
                </span>
                <span
                  *ngIf="formHotel.get('destination').hasError('minlength') && formHotel.get('destination').touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px"
                >
                  Mínimo 3 caracteres
                </span>
              </div>

              <div class="col-6 d-flex flex-column position-relative">
                <label class="field-label" for="arrivalDepartureDateTrigger">
                  Check-in - Check-out <span class="required-marker">*</span>
                </label>

                <!-- Hidden input bound to FormControl; drives the daterangepicker model -->
                <input
                  type="hidden"
                  readonly
                  formControlName="arrivalDepartureDate"
                  autocomplete="off"
                  class="form-control ngxDaterangepickerMd"
                  ngxDaterangepickerMd
                  [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
                  startKey="start"
                  endKey="end"
                  [(ngModel)]="dateRange"
                  [autoApply]="true"
                  [closeOnAutoApply]="true"
                  [minDate]="now"
                  [maxDate]="maxDateOffline"
                  (startDateChanged)="startDateClicked($event)"
                  (endDateChanged)="endDateClicked($event)"
                  name="daterange"
                  #dateRangePicker
                />

                <!-- Visible input that opens the picker -->
                <div class="position-relative w-100">
                  <span
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="left: 12px; top: 50%; transform: translateY(-50%); color: #171717; pointer-events: none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    readonly
                    [value]="dateRangeLabel"
                    placeholder="Check-in - Check-out"
                    class="form-control input-search-box ngx-daterangepicker-action"
                    style="background-color: white; padding-left: 40px"
                    (click)="openDatePickerSimple()"
                    id="arrivalDepartureDateTrigger"
                  />
                </div>
                <span
                  *ngIf="formHotel.get('arrivalDepartureDate')?.invalid && formHotel.get('arrivalDepartureDate')?.touched"
                  class="field-error"
                  data-form-invalid="hotel"
                >
                  {{ requiredFieldMessage('hotel', 'arrivalDepartureDate') }}
                </span>
              </div>
            </div>


            <!-- Row B: Nombre del hotel (repeateable) -->
            <div class="row m-0 mt-2 w-100" style="align-items: flex-end">
              <div class="col-8 d-flex flex-column pl-0">
                <label class="field-label" for="hotelName_0">Nombre del hotel <span class="required-marker">*</span></label>
                <span
                  *ngIf="selectedDestinationIata"
                  class="mb-1 d-inline-flex align-items-center"
                  style="font-family: 'Rubik', serif; font-size: 12px; color: #2f9e5f; font-weight: 500; gap: 0.5em"
                >
                  <span>Mostrando hoteles de {{ capitalize(selectedDestinationIata) }}</span>
                  <span *ngIf="loadingHotelsByCity" class="d-inline-flex align-items-center" style="gap: 0.4em; color: #999">
                    <span
                      class="d-inline-block"
                      style="
                        width: 10px;
                        height: 10px;
                        border: 1.5px solid #999;
                        border-top-color: transparent;
                        border-radius: 50%;
                        animation: form-offline-spin 0.7s linear infinite;
                      "
                    ></span>
                    <span style="font-size: 11px">Cargando hoteles...</span>
                  </span>
                </span>
                <div formArrayName="hotelNames" class="d-flex flex-column w-100" style="gap: 0.5em">
                  <div
                    *ngFor="let ctrl of hotelNamesArray.controls; let i = index"
                    class="d-flex align-items-center w-100"
                    style="gap: 0.5em"
                  >
                    <div class="position-relative flex-grow-1 w-100" [formGroupName]="i">
                      <input
                        *ngIf="i === 0"
                        type="text"
                        [id]="'hotelName_' + i"
                        [name]="'hotelName_' + i"
                        matInput
                        class="form-control"
                        placeholder="Escribí el nombre del hotel"
                        [maxLength]="100"
                        formControlName="name"
                        [matAutocomplete]="autoHotelsName"
                        #hotelsNameTrigger="matAutocompleteTrigger"
                        autocomplete="off"
                      />
                      <input
                        *ngIf="i > 0"
                        type="text"
                        [id]="'hotelName_' + i"
                        [name]="'hotelName_' + i"
                        class="form-control"
                        placeholder="Escribí el nombre del hotel"
                        [maxLength]="100"
                        formControlName="name"
                        autocomplete="off"
                      />
                      <span
                        *ngIf="ctrl.get('name')?.hasError('required') && ctrl.get('name')?.touched"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px; font-weight: 600; bottom: -18px"
                        >{{ requiredFieldMessage('hotel', 'hotelNames[' + i + '].name') }}</span
                      >
                    </div>
                    <button
                      *ngIf="i > 0"
                      type="button"
                      (click)="removeHotelName(i)"
                      aria-label="Eliminar hotel"
                      style="
                        min-width: 46px;
                        height: 48px;
                        border: none;
                        background-color: #fef2f2;
                        color: #dc2626;
                        border-radius: 6px;
                        font-size: 18px;
                      "
                    >
                      ×
                    </button>
                  </div>
                </div>

                <!-- mat-autocomplete moved OUTSIDE formArrayName as a sibling -->
                <mat-autocomplete
                  #autoHotelsName="matAutocomplete"
                  [displayWith]="displayHotelsNameFn"
                  (optionSelected)="onHotelsNameSelected($event.option.value)"
                >
                  <ng-container *ngFor="let item of hotelsNameOptions">
                    <ng-container *ngIf="item.type === 'hotel' && item.hotels && item.hotels.length > 0">
                      <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center" style="gap: 0.25em">
                            <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                            <span
                              class="mt-1"
                              style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                              >Hotel</span
                            >
                          </div>
                          <div>
                            <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                              {{ item.hotels.length }} resultados
                            </span>
                          </div>
                        </div>
                      </mat-option>
                      <mat-option *ngFor="let hotel of item.hotels" [value]="hotel">
                        <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                          <img src="{{ hotel?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                          <p
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                          >
                            {{ capitalize(hotel.name) }},
                            <span
                              class="mb-0"
                              style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                            >
                              {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }}
                              {{ capitalize(hotel.city_province) }}{{ hotel.city_province ? "," : "" }}
                              {{ capitalize(hotel.country_name) }}
                            </span>
                          </p>
                        </div>
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </mat-autocomplete>
              </div>
              <div class="col-4 d-flex flex-column pr-0">
                <label class="field-label">Valor estimado por noche</label>
                <div class="position-relative w-100">
                  <span
                    class="position-absolute"
                    style="left: 14px; top: 50%; transform: translateY(-50%); color: #737373; font-family: &quot;Rubik&quot;, sans-serif; font-size: 14px; font-weight: 500; pointer-events: none"
                  >
                    {{ hasReferentialCost ? 'ARS' : '' }}
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    id="estimatedRate"
                    name="estimatedRate"
                    formControlName="estimatedRate"
                    [placeholder]="hasReferentialCost ? '0,00' : 'Sin valor de referencia'"
                    [style.background-color]="hasReferentialCost ? '#f7f7f7' : '#fafafa'"
                    [style.padding-right]="!hasReferentialCost ? '38px' : '12px'"
                    readonly
                  />
                  <!-- Icono "sin dato": aparece sólo cuando no hay valor de referencia y NO se está consultando -->
                  <span
                    *ngIf="!hasReferentialCost && !loadingReferentialCost"
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="right: 10px; top: 50%; transform: translateY(-50%); color: #999; pointer-events: auto;"
                    tooltip="Por el momento no tenemos un valor de referencia para este hotel"
                    placement="left"
                    aria-label="Sin valor de referencia"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </span>
                  <!-- Spinner: aparece mientras se consulta /referential-costs. Mismo animation
                       `form-offline-spin` ya definida en el SCSS de este componente. -->
                  <span
                    *ngIf="loadingReferentialCost"
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="right: 10px; top: 50%; transform: translateY(-50%); color: #999; pointer-events: none;"
                    aria-label="Buscando valor de referencia"
                  >
                    <span
                      style="
                        width: 14px;
                        height: 14px;
                        border: 2px solid #5dc795;
                        border-top-color: transparent;
                        border-radius: 50%;
                        animation: form-offline-spin 0.7s linear infinite;
                        display: inline-block;
                      "
                    ></span>
                  </span>
                </div>
              </div>
            </div>

            <!-- Row C: Habitaciones y pasajeros (col-6) + Total de pasajeros (col-3) + Presupuesto estimado (col-3) -->
            <div class="row mt-2">
              <div class="col-6 d-flex flex-column">
                <label class="field-label">Habitaciones y pasajeros</label>
                <button
                  type="button"
                  class="d-flex justify-content-between align-items-center form-control btn-rooms-passengers"
                  (click)="openModal(); setRoomAndPassengers()"
                  [disabled]="edit"
                >
                  <span class="d-inline-flex align-items-center" style="gap: 10px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="color: #171717"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    {{ roomsAndPassengers }}
                  </span>
                  <img width="10" height="10" src="../../../../assets/img/app/little-icons/arrow-down-black.svg" />
                </button>
                <span
                  *ngIf="hasRoomError()"
                  class="field-error"
                  data-form-invalid="hotel"
                >
                  {{ roomsErrorMessage() }}
                </span>

                <!-- Modal selector — UNCHANGED -->
                <div *ngIf="isCollapsed" class="d-flex flex-column mt-2 config-passenger" style="position: relative; width: 100%">
                  <div class="card py-4 pl-5 pr-5 scrollable-card-container" style="width: 100%; min-width: 100%">
                    <div class="d-flex align-items-center justify-content-center" style="gap: 40px; margin-bottom: 15px">
                      <div class="d-flex flex-column align-items-center justify-content-center">
                        <label
                          class="mb-0"
                          style="
                            font-family: &quot;Rubik&quot; !important;
                            font-size: 14px !important;
                            font-weight: 600 !important;
                            line-height: 1;
                          "
                          >Adultos</label
                        >
                        <p
                          class="mb-0"
                          style="
                            font-family: &quot;Rubik&quot; !important;
                            font-size: 11px !important;
                            font-weight: 400 !important;
                            line-height: 1;
                          "
                        >
                          + de 18 años
                        </p>
                      </div>
                      <div class="container-label d-flex">
                        <div class="d-flex flex-column align-items-start">
                          <div class="d-flex" style="line-height: 1">
                            <label
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot; !important;
                                font-size: 14px !important;
                                font-weight: 600 !important;
                                line-height: 1;
                              "
                              >Niños</label
                            >
                          </div>
                          <p
                            class="mb-0"
                            style="
                              font-family: &quot;Rubik&quot; !important;
                              font-size: 11px !important;
                              font-weight: 400 !important;
                              line-height: 1;
                            "
                          >
                            - de 18 años
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="room-content">
                      <ng-container formArrayName="room">
                        <div
                          *ngFor="let item of formRoom(formHotel, 'room'); let i = index"
                          class="d-flex flex-row col-12 align-items-center justify-content-between p-2"
                        >
                          <div
                            [formGroupName]="i"
                            style="width: 100%"
                            [ngStyle]="{ 'border-bottom': formRoom(item, 'childsage').length > 0 ? 'none' : '2px dotted #9c9c9c' }"
                          >
                            <div class="d-flex flex-column">
                              <div class="d-flex flex-row align-items-center justify-content-between p-0 pb-3">
                                <div>
                                  <div
                                    class="mr-2 ml-1"
                                    style="font-family: &quot;Rubik&quot;; font-size: 14px; font-weight: 500; width: 50px"
                                  >
                                    Hab: {{ i + 1 }}
                                  </div>
                                </div>
                                <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                                  <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                    <button
                                      type="button"
                                      class="pr-2"
                                      style="border: none; background-color: transparent"
                                      (click)="decrementPassengerAdult(i, $event)"
                                      [disabled]="getPassengerCountAdult(i) <= 1"
                                    >
                                      <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                    </button>
                                    <input
                                      type="number"
                                      class="form-control text-center"
                                      style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                                      [value]="getPassengerCountAdult(i)"
                                      [min]="1"
                                      [max]="10"
                                      (change)="validatePassengerInput($event, i)"
                                      (keydown)="handleAdultInput($event, i)"
                                      (blur)="handleAdultBlur($event, i)"
                                      (click)="preventModalClose($event)"
                                      name="adults"
                                    />
                                    <button
                                      type="button"
                                      class="pl-2"
                                      style="border: none; background-color: transparent"
                                      (click)="incrementPassengerAdult(i, $event)"
                                      [disabled]="getPassengerCountAdult(i) >= 10"
                                    >
                                      <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                    </button>
                                  </div>
                                  <span
                                    *ngIf="item.get('qtyAdults')?.invalid && item.get('qtyAdults')?.touched"
                                    class="text-danger mt-1"
                                    style="font-size: 11px; font-weight: 600; white-space: nowrap"
                                  >
                                    {{ requiredFieldMessage('hotel', 'room[' + i + '].qtyAdults') }}
                                  </span>
                                </div>
                                <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                                  <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                    <button
                                      type="button"
                                      style="border: none; background-color: transparent"
                                      class="pr-2"
                                      (click)="decrementPassengerChildren(i, item, $event)"
                                      [disabled]="getPassengerCountChildren(i) <= 0"
                                    >
                                      <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                    </button>
                                    <input
                                      type="number"
                                      class="form-control text-center"
                                      style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                                      [value]="getPassengerCountChildren(i)"
                                      [min]="0"
                                      [max]="10"
                                      (change)="validatePassengerInput($event, i)"
                                      (keydown)="handleChildrenInput($event, i)"
                                      (blur)="handleChildrenBlur($event, i)"
                                      (click)="preventModalClose($event)"
                                      name="children"
                                    />
                                    <button
                                      type="button"
                                      style="border: none; background-color: transparent"
                                      class="pl-2"
                                      (click)="incrementPassengerChildren(i, item, $event)"
                                      [disabled]="getPassengerCountChildren(i) >= 10"
                                    >
                                      <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                    </button>
                                  </div>
                                </div>
                                <div id="childrenAges" class="d-flex flex-column ml-2" *ngIf="item.get('childsage').length > 0">
                                  <div *ngIf="hasChildAgeError(item, 'childsage')">
                                    <span class="help-block text-danger d-flex w-100 text-nowrap">La edad de los niños es incorrecta</span>
                                  </div>
                                  <div *ngIf="item.get('childsage')?.invalid && item.get('childsage')?.touched && !hasChildAgeError(item, 'childsage')">
                                    <span class="help-block text-danger d-flex w-100 text-nowrap">Indicá la edad de cada niño</span>
                                  </div>
                                </div>
                                <div class="p-0 d-flex flex-column ml-auto ml-2">
                                  <button
                                    type="button"
                                    (click)="removeRoom(i, $event)"
                                    class="ml-2 btn btn-outline-danger col-12 input-age btn-sm"
                                    style="
                                      min-height: 35px !important;
                                      width: 45px !important;
                                      height: 45px !important;
                                      border-radius: 8px;
                                      border: 1px solid #ced4da !important;
                                    "
                                    [disabled]="formRoom(formHotel, 'room').length <= 1"
                                  >
                                    <i class="bi bi-x-lg" style="color: black; font-size: 16px; -webkit-text-stroke: 0.5px"></i>
                                  </button>
                                </div>
                              </div>
                              <div>
                                <div
                                  *ngIf="formRoom(item, 'childsage').length > 0"
                                  class="d-flex flex-column p-4 m-0"
                                  style="border-radius: 10px; background-color: #f4f4f4"
                                >
                                  <div class="d-flex flex-column align-items-start mb-3 ml-1">
                                    <label
                                      class="mb-0"
                                      style="
                                        font-family: &quot;Rubik&quot; !important;
                                        font-size: 14px !important;
                                        font-weight: 600 !important;
                                        line-height: 1;
                                        text-wrap: nowrap;
                                      "
                                      for="adults"
                                      >Edad niños
                                      <span style="font-weight: 400 !important; font-size: 12px !important">- de 18 años</span></label
                                    >
                                  </div>
                                  <div class="d-flex mb-3">
                                    <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                      <div *ngIf="j >= 0 && j <= 3">
                                        <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                          <select
                                            name="age"
                                            id="age"
                                            formControlName="age"
                                            [ngStyle]="{ 'margin-left': j > 0 ? '1em' : '' }"
                                            class="form-control custom-select-arrow"
                                            style="
                                              height: 35px !important;
                                              padding: 0 !important;
                                              width: 60px !important;
                                              font-family: &quot;Rubik&quot; !important;
                                              font-size: 14px !important;
                                              font-weight: 600 !important;
                                              text-align: left;
                                              padding-left: 13px !important;
                                              background-color: #ffffff !important;
                                              border-radius: 12px;
                                            "
                                          >
                                            <ng-container *ngFor="let value of agesChildsArr()">
                                              <option value="{{ value }}">{{ value }}</option>
                                            </ng-container>
                                          </select>
                                          <span
                                            style="
                                              position: absolute;
                                              top: 42%;
                                              right: 0.5em;
                                              width: 0;
                                              height: 0;
                                              border-left: 4px solid transparent;
                                              border-right: 4px solid transparent;
                                              border-top: 6px solid #00d096;
                                            "
                                          ></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="d-flex mb-3">
                                    <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                      <div *ngIf="j >= 4 && j <= 7">
                                        <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                          <select
                                            name="age"
                                            id="age"
                                            formControlName="age"
                                            [ngStyle]="{ 'margin-left': j > 4 ? '1em' : '' }"
                                            class="form-control custom-select-arrow"
                                            style="
                                              height: 35px !important;
                                              padding: 0 !important;
                                              width: 60px !important;
                                              font-family: &quot;Rubik&quot; !important;
                                              font-size: 14px !important;
                                              font-weight: 600 !important;
                                              text-align: left;
                                              padding-left: 13px !important;
                                              background-color: #ffffff !important;
                                              border-radius: 12px;
                                            "
                                          >
                                            <ng-container *ngFor="let value of agesChildsArr()">
                                              <option value="{{ value }}">{{ value }}</option>
                                            </ng-container>
                                          </select>
                                          <span
                                            style="
                                              position: absolute;
                                              top: 42%;
                                              right: 1em;
                                              width: 0;
                                              height: 0;
                                              border-left: 4px solid transparent;
                                              border-right: 4px solid transparent;
                                              border-top: 6px solid #00d096;
                                            "
                                          ></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="d-flex">
                                    <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                      <div *ngIf="j >= 8 && j <= 9">
                                        <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                          <select
                                            name="age"
                                            id="age"
                                            formControlName="age"
                                            [ngStyle]="{ 'margin-left': j === 9 ? '1em' : '' }"
                                            class="form-control custom-select-arrow"
                                            style="
                                              height: 35px !important;
                                              padding: 0 !important;
                                              width: 60px !important;
                                              font-family: &quot;Rubik&quot; !important;
                                              font-size: 14px !important;
                                              font-weight: 600 !important;
                                              text-align: left;
                                              padding-left: 13px !important;
                                              background-color: #ffffff !important;
                                              border-radius: 12px;
                                            "
                                          >
                                            <ng-container *ngFor="let value of agesChildsArr()">
                                              <option value="{{ value }}">{{ value }}</option>
                                            </ng-container>
                                          </select>
                                          <span
                                            style="
                                              position: absolute;
                                              top: 42%;
                                              right: 1em;
                                              width: 0;
                                              height: 0;
                                              border-left: 4px solid transparent;
                                              border-right: 4px solid transparent;
                                              border-top: 6px solid #00d096;
                                            "
                                          ></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>

                    <div class="py-2 row">
                      <div class="col-6 p-2">
                        <button
                          type="button"
                          (click)="addRoom($event)"
                          class="badge btn-choice-add"
                          style="background-color: transparent; min-width: 145px; width: 100%; height: 36px; border: 1px solid #00d096"
                          (mouseenter)="isHoverRoom = true; updateButtonColorRoom()"
                          (mouseleave)="isHoverRoom = false; updateButtonColorRoom()"
                        >
                          Agregar Habitación
                        </button>
                      </div>
                      <div class="col-6 p-2">
                        <button
                          (click)="confirmRoomsAndPassengers($event)"
                          class="badge btn-choice-confirm"
                          style="border: none; min-width: 145px; width: 100%; height: 36px; background-color: #00d096; color: white"
                          type="button"
                          (mouseenter)="isHoverConfirm = true; updateButtonColorConfirm()"
                          (mouseleave)="isHoverConfirm = false; updateButtonColorConfirm()"
                        >
                          Confirmar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 d-flex flex-column">
                <label class="field-label" for="totalPassengers">Total de pasajeros</label>
                <input
                  type="text"
                  id="totalPassengers"
                  name="totalPassengers"
                  class="form-control"
                  [value]="totalPassengersLabel"
                  placeholder="0"
                  readonly
                  style="background-color: #f7f7f7"
                />
              </div>

              <div class="col-3 d-flex flex-column">
                <label class="field-label" for="price_night">Tarifa por noche</label>
                <div class="d-flex align-items-center" style="border: 1px solid #ced4da; border-radius: 4px; overflow: hidden; background-color: #fff">
                  <span
                    style="
                      padding: 0.5rem 0.75rem;
                      background-color: #f7f7f7;
                      color: #737373;
                      font-family: &quot;Rubik&quot;, sans-serif;
                      font-size: 14px;
                      font-weight: 500;
                      border-right: 1px solid #e5e5e5;
                      white-space: nowrap;
                    "
                  >
                    ARS
                  </span>
                  <input
                    type="text"
                    inputmode="decimal"
                    class="form-control border-0"
                    id="price_night"
                    name="price_night"
                    placeholder="0.00"
                    (keydown)="blockInvalidKeys($event, 'price')"
                    (input)="onPriceNightInput($event)"
                    (blur)="onPriceNightBlur($event)"
                    formControlName="price_night"
                    style="padding-left: 12px; box-shadow: none !important"
                  />
                </div>
              </div>
            </div>

            <!-- Row D: Nacionalidad (col-6) -->
            <div class="row mt-2">
              <div class="col-6 d-flex flex-column">
                <label class="field-label">Nacionalidad</label>
                <ng-container *ngIf="selectNationalityName === ''">
                  <input
                    type="text"
                    id="nationality"
                    name="nationality"
                    matInput
                    class="form-control"
                    placeholder="Nacionalidad"
                    autocomplete="off"
                    formControlName="nationality"
                    [matAutocomplete]="autoNationality"
                    (focus)="getNationalities()"
                    (input)="filterNationalities($any($event.target).value)"
                  />
                  <mat-autocomplete #autoNationality="matAutocomplete" (optionSelected)="onNationalitySelected($event.option.value)">
                    <mat-option
                      *ngFor="let country of filteredNationalities"
                      [value]="country.country_name"
                      style="font-family: &quot;Rubik&quot;, serif; padding: 0px 10px !important; height: 35px !important"
                    >
                      {{ country.country_name }}
                    </mat-option>
                  </mat-autocomplete>
                </ng-container>
                <ng-container *ngIf="selectNationalityName !== ''">
                  <input
                    type="text"
                    id="nationality"
                    name="nationality"
                    class="form-control"
                    aria-label="nationality"
                    [value]="selectNationalityName"
                    style="padding-right: 38px"
                  />
                  <span
                    *ngIf="!edit"
                    class="position-absolute d-flex align-items-center justify-content-center"
                    style="top: 0; right: 0; height: 100%; width: 38px; cursor: pointer"
                    tooltip="Eliminar nacionalidad"
                    placement="bottom"
                    (click)="resetNationality()"
                  >
                    <i class="bi bi-x" style="font-size: 20px; color: #999"></i>
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </section>

        <hr class="mt-4 mb-5 p-0" style="border-color: oklch(70.8% 0 0)" />

        <!-- ============================================= -->
        <!-- BLOCK 3: Preferencias -->
        <!-- ============================================= -->
        <section class="border-t border-neutral-400 pt-8 mb-5">
          <div class="block-header">
            <div class="block-number">3</div>
            <div class="block-header-text">
              <p class="block-title">Preferencias</p>
              <p class="block-caption">Detalles de la estadía.</p>
            </div>
          </div>
          <div class="block-body">
            <div class="row">
              <!-- Régimen -->
              <div class="col-6">
                <div class="card-option d-flex flex-column">
                  <div class="card-label-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="card-label-icon"
                      aria-hidden="true"
                    >
                      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                      <path d="M7 2v20" />
                      <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                    </svg>
                    <span class="card-label-text">Régimen</span>
                  </div>
                  <div *ngFor="let val of boardType; let i = index">
                    <label
                      class="option-item"
                      [ngStyle]="{ 'border-bottom': i !== boardType.length - 1 ? '1px solid rgba(229,229,229,0.8)' : '' }"
                    >
                      <span class="option-label"
                        ><strong>{{ val.description }}</strong> - {{ val.label }}</span
                      >
                      <span class="custom-checkbox">
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event, 'hotel', 'meals')"
                          [checked]="formHotel.get('meals').value.includes(val.value)"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Categoría habitación -->
              <div class="col-6">
                <div class="card-option d-flex flex-column">
                  <div class="card-label-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="card-label-icon"
                      aria-hidden="true"
                    >
                      <path d="M13 4h3a2 2 0 0 1 2 2v14" />
                      <path d="M2 20h3" />
                      <path d="M13 4h0" />
                      <path d="M13 4H6a2 2 0 0 0-2 2v14" />
                      <path d="M22 20h-3" />
                      <path d="M2 20h20" />
                    </svg>
                    <span class="card-label-text">Categoría habitación</span>
                  </div>
                  <div *ngFor="let val of roomType; let i = index">
                    <label
                      class="option-item"
                      [ngStyle]="{ 'border-bottom': i !== roomType.length - 1 ? '1px solid rgba(229,229,229,0.8)' : '' }"
                    >
                      <span class="option-label">{{ val.label }}</span>
                      <span class="custom-checkbox">
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event, 'hotel', 'category')"
                          [checked]="formHotel.get('category').value.includes(val.value)"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Tipo cama -->
              <div class="col-6">
                <div class="card-option d-flex flex-column">
                  <div class="card-label-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="card-label-icon"
                      aria-hidden="true"
                    >
                      <path d="M2 4v16" />
                      <path d="M2 8h18a2 2 0 0 1 2 2v10" />
                      <path d="M2 17h20" />
                      <path d="M6 8v9" />
                    </svg>
                    <span class="card-label-text">Tipo cama</span>
                  </div>
                  <div *ngFor="let val of bedType; let i = index">
                    <label
                      class="option-item"
                      [ngStyle]="{ 'border-bottom': i !== bedType.length - 1 ? '1px solid rgba(229,229,229,0.8)' : '' }"
                    >
                      <span class="option-label">{{ val.label }}</span>
                      <span class="custom-checkbox">
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event, 'hotel', 'type_bed')"
                          [checked]="formHotel.get('type_bed').value.includes(val.value)"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Política de cancelación -->
              <div class="col-6">
                <div class="card-option d-flex flex-column">
                  <div class="card-label-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="card-label-icon"
                      aria-hidden="true"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                    <span class="card-label-text">Política de cancelación</span>
                  </div>
                  <div *ngFor="let val of cancellationPolicyOptions; let i = index">
                    <label class="option-item">
                      <span class="option-label">{{ val.label }}</span>
                      <span class="custom-checkbox">
                        <input
                          type="radio"
                          formControlName="cancellationPolicy"
                          name="cancellationPolicy"
                          [value]="val.value === null ? '' : val.value"
                          [disabled]="edit"
                        />
                        <span class="checkbox-visual"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <hr class="mt-4 mb-5 p-0" style="border-color: oklch(70.8% 0 0)" *ngIf="!edit && !hasAnyHotelSelected" />

        <!-- ============================================= -->
        <!-- BLOCK 4: Ampliar información de búsqueda -->
        <!-- ============================================= -->
        <section class="border-t border-neutral-400 pt-8 mb-5" *ngIf="!edit && !hasAnyHotelSelected">
          <div class="block-header">
            <div class="block-number">4</div>
            <div class="block-header-text">
              <p class="block-title">Ampliar información de búsqueda</p>
              <p class="block-caption">Opciones adicionales para mejorar los resultados.</p>
            </div>
          </div>
          <div class="block-body">
            <div class="d-flex justify-content-start">
              <button
                type="button"
                (click)="toggleExpandSearch()"
                [style.border]="expandSearchSection ? '1px solid oklch(0.58 0.13 162)' : '1px dashed #d4d4d4'"
                [style.background-color]="expandSearchSection ? 'oklch(0.97 0.035 162)' : 'white'"
                class="d-inline-flex align-items-center rounded-full px-3 py-2"
                style="gap: 0.5rem; transition: all 0.15s; cursor: pointer; font-family: &quot;Poppins&quot;, sans-serif; font-weight: 600"
              >
                <span
                  class="d-inline-flex align-items-center justify-content-center"
                  style="height: 20px; width: 20px; border-radius: 9999px; background-color: oklch(0.93 0.06 162); color: #171717"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    [style.transform]="expandSearchSection ? 'rotate(45deg)' : 'rotate(0deg)'"
                    style="transition: transform 0.3s"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </span>
                <span style="font-size: 12px; color: #171717">Ampliar información de búsqueda</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  [style.transform]="expandSearchSection ? 'rotate(180deg)' : 'rotate(0deg)'"
                  style="transition: transform 0.3s; color: #737373"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
            </div>

            <div *ngIf="expandSearchSection" class="d-flex flex-column mt-3 animate-fade-in" style="gap: 0.75rem; padding-top: 0.5rem">
              <label class="field-label" for="hotelSuggestInput">Nombre del hotel</label>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <div class="position-relative flex-grow-1 w-100">
                  <span
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="left: 12px; top: 50%; transform: translateY(-50%); color: #171717; pointer-events: none"
                  >
                    <i class="bi bi-building" style="font-size: 18px;"></i>
                  </span>
                  <input
                    type="text"
                    id="hotelSuggestInput"
                    name="hotelSuggestInput"
                    class="form-control"
                    matInput
                    #hotelSuggestInput="matAutocompleteTrigger"
                    [matAutocomplete]="autoHotelSuggest"
                    [style.padding-left]="'40px'"
                    [style.padding-right]="hotelSuggestLoading ? '36px' : '12px'"
                    placeholder="Buscá un hotel por nombre"
                    [(ngModel)]="hotelSuggestSearchInput"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onHotelSuggestInputChange($event)"
                    (focus)="onHotelSuggestFocus()"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <span
                    *ngIf="hotelSuggestLoading"
                    class="position-absolute d-inline-flex align-items-center justify-content-center"
                    style="right: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;"
                  >
                    <span
                      style="
                        width: 14px;
                        height: 14px;
                        border: 2px solid #5dc795;
                        border-top-color: transparent;
                        border-radius: 50%;
                        animation: form-offline-spin 0.7s linear infinite;
                        display: inline-block;
                      "
                    ></span>
                  </span>
                </div>
                <button
                  type="button"
                  class="btn"
                  style="background-color: #6c757d; color: #ffffff; border: none; border-radius: 6px; padding: 6px 14px; font-size: 13px; font-weight: 600;"
                  (click)="onHotelSuggestClear()">
                  Limpiar
                </button>
              </div>

              <!-- Loading state -->
              <div *ngIf="hotelSuggestLoading" class="text-center py-2" style="font-size: 12px; color: #999;">
                Buscando hoteles...
              </div>

              <!-- Error state -->
              <div *ngIf="hotelSuggestError && !hotelSuggestLoading" style="font-size: 12px; color: #c62828;">
                {{ hotelSuggestError }}
              </div>

              <!-- mat-autocomplete for hotel suggest -->
              <mat-autocomplete
                #autoHotelSuggest="matAutocomplete"
                (optionSelected)="onHotelSuggestSelected($event.option.value)"
              >
                <ng-container *ngIf="hotelSuggestResults.length > 0">
                  <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 0.25em">
                        <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                        <span class="mt-1" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important">Hoteles sugeridos</span>
                      </div>
                      <div>
                        <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                          {{ hotelSuggestResults.length }} resultados
                        </span>
                      </div>
                    </div>
                  </mat-option>
                  <mat-option *ngFor="let hotel of hotelSuggestResults" [value]="hotel">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <span
                        [title]="hotel.country_name || ''"
                        style="
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          width: 22px;
                          height: 22px;
                          border-radius: 50%;
                          background-color: #e9ecef;
                          color: #495057;
                          font-size: 10px;
                          font-weight: 700;
                          font-family: 'Rubik', sans-serif;
                          flex-shrink: 0;
                        ">
                        {{ (hotel.country_name || '').slice(0, 2).toUpperCase() }}
                      </span>
                      <p class="mb-0" style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                        {{ hotel.name || hotel.hotel_name }},
                        <span class="mb-0" style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important">
                          {{ hotel.city_name }}{{ hotel.city_name ? "," : "" }}
                          {{ hotel.country_name }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
          </div>
        </section>

        <hr class="mt-4 mb-5 p-0" style="border-color: oklch(70.8% 0 0)" />
        <section class="border-t border-neutral-400 pt-8">
          <div class="block-header">
            <div class="block-number">5</div>
            <div class="block-header-text">
              <p class="block-title">Comentarios u observaciones</p>
              <p class="block-caption">Agregá información adicional para tu equipo.</p>
            </div>
          </div>
          <div class="block-body">
            <div class="w-100 position-relative">
              <textarea
                name="comment_contact"
                id="comment_contact"
                class="form-control comment-textarea"
                style="background-color: #ffffff !important"
                placeholder="Pregunta o comentario"
                [maxLength]="500"
                formControlName="comment_contact"
                rows="5"
              ></textarea>
              <span
                *ngIf="formHotel.get('comment_contact').value?.length === 500"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Máximo 500 caracteres
              </span>
            </div>
          </div>
        </section>
        <!-- Footer -->
        <div *ngIf="!edit" class="form-footer">
          <p class="footer-disclaimer mb-0">Podés incluir diferentes servicios dentro de una misma solicitud.</p>
          <div class="footer-actions">
            <button type="button" class="btn-borrar" (click)="close()">Cerrar</button>
            <button type="button" class="btn-enviar" (click)="onSubmit()">Enviar</button>
          </div>
        </div>
        <div *ngIf="reopen" class="form-footer">
          <p class="footer-disclaimer mb-0">*Vas a reabrir esta solicitud y actualizar su estado</p>
          <div class="footer-actions">
            <button type="button" class="btn-borrar" (click)="close()">Cancelar</button>
            <button type="button" class="btn-enviar" (click)="onReopenSubmit()">Reabrir y guardar</button>
          </div>
        </div>
      </div>
      <!-- /hotel-form-card -->
    </form>
  </div>
  <div [ngClass]="{ 'd-block': tab === 'transfer', 'd-none': tab != 'transfer' }">
    <usb-transfer-form
      [formGroup]="formTransfer"
      [selectedFileId]="selectedFileId"
      [selectedClientId]="selectedClientId"
      [availablePax]="availablePax"
      [requestReady]="requestReady"
      [selectedFile]="selectedFile"
      [selectedClient]="selectedClient"
      [loadingFiles]="loadingFiles"
      [loadingPax]="loadingPax"
      [loadingCountries]="loadingCountries"
      [showNewFileNameInput]="showNewFileNameInput"
      [showNewClientInput]="showNewClientInput"
      [existingFiles]="existingFiles"
      [countriesData]="countriesData"
      [newFilePassenger]="newFilePassenger"
      [newFilePassengerError]="newFilePassengerError"
      [newFilePhoneCode]="newFilePhoneCodeModel"
      [newFilePhoneCodeError]="newFilePhoneCodeError"
      [newFilePhone]="newFilePhone"
      [newFilePhoneError]="newFilePhoneError"
      [newFileEmail]="newFileEmail"
      [newFileEmailError]="newFileEmailError"
      [phoneCodeSelected]="phoneCodeSelected"
      [edit]="edit"
      [requiredFieldMessage]="requiredFieldMessage"
      [getFileLabel]="getFileLabel"
      [getClientLabel]="getClientLabel"
      [getClientsForSelectedFile]="getClientsForSelectedFile"
      [isNuevoFileValid]="isNuevoFileValid"
      [blockInvalidKeys]="blockInvalidKeys"
      (fileChange)="onFileChange($event)"
      (fileSearchInput)="onFileSearchInput($event)"
      (clearSelectedFile)="clearSelectedFile()"
      (clientChange)="onClientChange($event)"
      (paxChange)="onPaxChange($event)"
      (passengerIdChange)="onPassengerIdChange($event)"
      (passengerFirstNameChange)="onPassengerFirstNameChange($event)"
      (passengerLastNameChange)="onPassengerLastNameChange($event)"
      (requestTypeChange)="onRequestTypeChange($event)"
      (newFileToggle)="openNewFileNameInput()"
      (newClientToggle)="cancelNewClient()"
      (newFileSubmit)="onCreateNewFile()"
      (newClientSubmit)="onCreateNewClient($event)"
      (newFilePassengerInput)="onNewFilePassengerInput($event)"
      (newFilePhoneCodeInput)="onNewFilePhoneCodeInput($event)"
      (newFileCountrySelected)="onNewFileCountrySelected($event)"
      (newFilePhoneInput)="onNewFilePhoneInput($event)"
      (newFileEmailInput)="onNewFileEmailInput($event)"
      (countrySelected)="onCountrySelected($event)"
      (phoneCodeInput)="onPhoneCodeInput($event)"
      (clientFirstNameChange)="onClientFirstNameChange($event)"
      (clientLastNameChange)="onClientLastNameChange($event)"
      (clientEmailChange)="onClientEmailChange($event)"
      (clientPhoneChange)="onClientPhoneChange($event)"
      (submit)="onTransferSubmit($event)"
      (clear)="onTransferClear()"
    ></usb-transfer-form>
  </div>
  <div [ngClass]="{ 'd-block': tab === 'experience', 'd-none': tab != 'experience' }">
    <usb-experience-form
      [formGroup]="formExperience"
      [selectedFileId]="selectedFileId"
      [selectedClientId]="selectedClientId"
      [availablePax]="availablePax"
      [requestReady]="requestReady"
      [selectedFile]="selectedFile"
      [selectedClient]="selectedClient"
      [loadingFiles]="loadingFiles"
      [loadingPax]="loadingPax"
      [loadingCountries]="loadingCountries"
      [showNewFileNameInput]="showNewFileNameInput"
      [showNewClientInput]="showNewClientInput"
      [existingFiles]="existingFiles"
      [countriesData]="countriesData"
      [newFilePassenger]="newFilePassenger"
      [newFilePassengerError]="newFilePassengerError"
      [newFilePhoneCode]="newFilePhoneCodeModel"
      [newFilePhoneCodeError]="newFilePhoneCodeError"
      [newFilePhone]="newFilePhone"
      [newFilePhoneError]="newFilePhoneError"
      [newFileEmail]="newFileEmail"
      [newFileEmailError]="newFileEmailError"
      [phoneCodeSelected]="phoneCodeSelected"
      [edit]="edit"
      [requiredFieldMessage]="requiredFieldMessage"
      [getFileLabel]="getFileLabel"
      [getClientLabel]="getClientLabel"
      [getClientsForSelectedFile]="getClientsForSelectedFile"
      [isNuevoFileValid]="isNuevoFileValid"
      [blockInvalidKeys]="blockInvalidKeys"
      (fileChange)="onFileChange($event)"
      (fileSearchInput)="onFileSearchInput($event)"
      (clearSelectedFile)="clearSelectedFile()"
      (clientChange)="onClientChange($event)"
      (paxChange)="onPaxChange($event)"
      (passengerIdChange)="onPassengerIdChange($event)"
      (passengerFirstNameChange)="onPassengerFirstNameChange($event)"
      (passengerLastNameChange)="onPassengerLastNameChange($event)"
      (requestTypeChange)="onRequestTypeChange($event)"
      (newFileToggle)="openNewFileNameInput()"
      (newClientToggle)="cancelNewClient()"
      (newFileSubmit)="onCreateNewFile()"
      (newClientSubmit)="onCreateNewClient($event)"
      (newFilePassengerInput)="onNewFilePassengerInput($event)"
      (newFilePhoneCodeInput)="onNewFilePhoneCodeInput($event)"
      (newFileCountrySelected)="onNewFileCountrySelected($event)"
      (newFilePhoneInput)="onNewFilePhoneInput($event)"
      (newFileEmailInput)="onNewFileEmailInput($event)"
      (countrySelected)="onCountrySelected($event)"
      (phoneCodeInput)="onPhoneCodeInput($event)"
      (clientFirstNameChange)="onClientFirstNameChange($event)"
      (clientLastNameChange)="onClientLastNameChange($event)"
      (clientEmailChange)="onClientEmailChange($event)"
      (clientPhoneChange)="onClientPhoneChange($event)"
      (submit)="onExperienceSubmit($event)"
      (clear)="onExperienceClear()"
    ></usb-experience-form>
  </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fa1a1a" type="line-scale">
  <p style="color: white">Loading...</p>
</ngx-spinner>
